// src/pages/driverReports/carSheets/CarExpenses/useCarSheet.js

import { useEffect, useState } from "react";
import { loadSheetFromFirestore } from "./loadSheet";
import { saveSheetToFirestore } from "./saveSheet";
import { recalcSummaries } from "./recalcSummaries";

export function useCarSheet(month, sheet) {
  const [baseSheet, setBaseSheet] = useState(null);
  const [incomeRows, setIncomeRows] = useState([]);
  const [expenseRows, setExpenseRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  // eslint-disable-next-line react-hooks/exhaustive-deps
useEffect(() => {
    if (!month || !sheet?.id) return;

    async function load() {
      try {
        setLoading(true);
        const data = await loadSheetFromFirestore(month, sheet);
        setBaseSheet(data);
        setIncomeRows(data.incomeRows || []);
        setExpenseRows(data.expensesRows || []);
      } catch (err) {
        setError(err.message);
      }
      setLoading(false);
    }

    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [month, sheet.id]);


  // Save handler
  async function save() {
    if (!baseSheet || !sheet?.id) return;

    setSaving(true);
    setError("");

    try {
      const summary = recalcSummaries(incomeRows, expenseRows);

      const updated = await saveSheetToFirestore(
        month,
        sheet.id,
        baseSheet,
        summary
      );

      setBaseSheet(updated);
setIncomeRows(updated.incomeRows || []);
setExpenseRows(updated.expensesRows || []);
    } catch (err) {
      setError(err.message);
    }

    setSaving(false);
  }

  return {
    baseSheet,
    incomeRows,
    expenseRows,
    setIncomeRows,
    setExpenseRows,
    loading,
    saving,
    error,
    save,
  };
}
